import { BINGO_BONUS, RACK_SIZE } from './types.js';
import { premiumAt } from './board.js';
import { valueOf } from './tile-values.js';
export function scoreWord(word) {
    let total = 0;
    let wordMultiplier = 1;
    for (const cell of word.cells) {
        const base = valueOf(cell.letter, cell.is_blank);
        let letterScore = base;
        if (cell.is_newly_placed) {
            const prem = premiumAt(cell.row, cell.col);
            switch (prem) {
                case 'DL':
                    letterScore = base * 2;
                    break;
                case 'TL':
                    letterScore = base * 3;
                    break;
                case 'DW':
                case 'STAR':
                    wordMultiplier *= 2;
                    break;
                case 'TW':
                    wordMultiplier *= 3;
                    break;
            }
        }
        total += letterScore;
    }
    return total * wordMultiplier;
}
export function scoreMove(primary, crosses, placedCount) {
    let total = primary ? scoreWord(primary) : 0;
    for (const cross of crosses)
        total += scoreWord(cross);
    if (placedCount === RACK_SIZE)
        total += BINGO_BONUS;
    return total;
}
//# sourceMappingURL=scorer.js.map